export const APP_LISTING_HOME_LINK = '/';

export const TEST_ID = {
  HEADER_ACTION_LINKS: 'app-listing__header-action-links',
} as const;
